import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const PAGE_LABELS = {
  home: 'Home',
  about: 'About Us',
  contact: 'Contact',
  features: 'Features',
  promo: 'Promo',
  news: 'News',
};

const s = {
  shell: { fontFamily: "'Inter', system-ui, sans-serif", color: '#1e293b', minHeight: '100vh', background: '#fff' },
  hero: { position: 'relative', minHeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', background: 'linear-gradient(135deg,#0f172a 0%,#1e3a5f 60%,#0f172a 100%)', overflow: 'hidden' },
  heroImg: { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.35 },
  heroContent: { position: 'relative', zIndex: 1, maxWidth: 680, padding: '80px 32px', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  h1: { fontSize: 'clamp(2.2rem, 5vw, 3.6rem)', fontWeight: 900, margin: '0 0 16px', lineHeight: 1.1, color: '#fff' },
  heroSub: { fontSize: '1.05rem', color: 'rgba(255,255,255,.78)', margin: '0 0 32px', lineHeight: 1.7 },
  ctaBtn: { display: 'inline-flex', alignItems: 'center', padding: '14px 30px', background: '#fff', color: '#0f172a', borderRadius: 999, fontWeight: 800, fontSize: '.95rem', textDecoration: 'none', border: 'none', cursor: 'pointer', transition: 'transform .15s' },
  section: { maxWidth: 900, margin: '0 auto', padding: '64px 24px' },
  sectionRow: { display: 'flex', gap: 48, alignItems: 'center', flexWrap: 'wrap' },
  sectionImg: { width: 360, maxWidth: '100%', borderRadius: 16, objectFit: 'cover', flexShrink: 0 },
  h2: { fontSize: 'clamp(1.4rem, 3.5vw, 2rem)', fontWeight: 700, margin: '0 0 16px' },
  body: { fontSize: '1rem', color: '#475569', lineHeight: 1.7, margin: '0 0 16px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 24, marginTop: 32 },
  card: { background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 14, padding: '24px 20px' },
  cardTitle: { fontWeight: 700, marginBottom: 8, fontSize: '1rem' },
  cardBody: { fontSize: '0.9rem', color: '#64748b', lineHeight: 1.6 },
  promoBox: { position: 'relative', borderRadius: 18, overflow: 'hidden', minHeight: 360, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 48 },
  promoBg: { position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' },
  promoOverlay: { position: 'absolute', inset: 0 },
  promoContent: { position: 'relative', maxWidth: 560, color: '#fff' },
  contactRow: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 32, flexWrap: 'wrap' },
  contactLabel: { fontWeight: 600, fontSize: '0.82rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 },
  contactVal: { fontSize: '1rem', color: '#1e293b', marginBottom: 20 },
  newsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 24, marginTop: 32 },
  newsCard: { border: '1px solid #e2e8f0', borderRadius: 14, overflow: 'hidden', background: '#fff' },
  newsImg: { width: '100%', height: 160, objectFit: 'cover', display: 'block' },
  newsBody: { padding: '16px 18px' },
  newsDate: { fontSize: '0.78rem', color: '#94a3b8', marginBottom: 6 },
  newsTitle: { fontWeight: 700, fontSize: '1rem', marginBottom: 8 },
  newsText: { fontSize: '0.9rem', color: '#64748b', lineHeight: 1.6 },
  galleryGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12, marginTop: 20 },
  galleryImg: { width: '100%', aspectRatio: '1', objectFit: 'cover', borderRadius: 10 },
  notFound: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh', color: '#64748b' },
  loading: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh', color: '#94a3b8', fontSize: '1rem' },
};

const HomeTemplate = ({ c, storeName }) => (
  <>
    <div style={s.hero}>
      {(c.heroImage || c.bannerImage) && <img src={c.heroImage || c.bannerImage} alt="" style={s.heroImg} />}
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom,rgba(15,23,42,.45),rgba(15,23,42,.65))' }} />
      <div style={s.heroContent}>
        <h1 style={s.h1}>{c.heroHeadline || storeName || 'Welcome'}</h1>
        {c.heroSubtext && <p style={s.heroSub}>{c.heroSubtext}</p>}
        {c.ctaLabel && (
          <a href={c.ctaUrl || '#'} style={s.ctaBtn}>{c.ctaLabel}</a>
        )}
      </div>
    </div>
    {(c.aboutHeadline || c.aboutText) && (
      <div style={s.section}>
        <div style={s.sectionRow}>
          <div style={{ flex: 1, minWidth: 240 }}>
            {c.aboutHeadline && <h2 style={s.h2}>{c.aboutHeadline}</h2>}
            {c.aboutText && <p style={s.body}>{c.aboutText}</p>}
          </div>
          {c.aboutImage && <img src={c.aboutImage} alt="" style={s.sectionImg} />}
        </div>
      </div>
    )}
  </>
);

const AboutTemplate = ({ c }) => (
  <div style={s.section}>
    {c.headline && <h1 style={{ ...s.h1, color: '#1e293b', marginBottom: 32 }}>{c.headline}</h1>}
    <div style={s.sectionRow}>
      <div style={{ flex: 1, minWidth: 260 }}>
        {c.story && <p style={s.body}>{c.story}</p>}
        {c.mission && (
          <blockquote style={{ borderLeft: '4px solid #2563eb', paddingLeft: 20, margin: '24px 0 0', fontStyle: 'italic', color: '#475569', lineHeight: 1.7 }}>
            {c.mission}
          </blockquote>
        )}
      </div>
      {c.mainImage && <img src={c.mainImage} alt="" style={s.sectionImg} />}
    </div>
  </div>
);

const ContactTemplate = ({ c }) => (
  <div style={s.section}>
    {c.headline && <h1 style={{ ...s.h1, color: '#1e293b', marginBottom: 12 }}>{c.headline}</h1>}
    {c.introText && <p style={{ ...s.body, marginBottom: 40 }}>{c.introText}</p>}
    <div style={{ display: 'flex', gap: 48, flexWrap: 'wrap' }}>
      <div style={{ flex: 1, minWidth: 220 }}>
        {c.phone && (
          <div>
            <div style={s.contactLabel}>Phone</div>
            <div style={s.contactVal}><a href={`tel:${c.phone}`} style={{ color: '#2563eb', textDecoration: 'none' }}>{c.phone}</a></div>
          </div>
        )}
        {c.email && (
          <div>
            <div style={s.contactLabel}>Email</div>
            <div style={s.contactVal}><a href={`mailto:${c.email}`} style={{ color: '#2563eb', textDecoration: 'none' }}>{c.email}</a></div>
          </div>
        )}
        {c.address && (
          <div>
            <div style={s.contactLabel}>Address</div>
            <div style={s.contactVal}>{c.address}</div>
          </div>
        )}
      </div>
      {c.mapsEmbedUrl && (
        <iframe
          title="location"
          src={c.mapsEmbedUrl}
          style={{ flex: 2, minWidth: 280, height: 320, border: 0, borderRadius: 14 }}
          allowFullScreen
          loading="lazy"
        />
      )}
    </div>
  </div>
);

const FeaturesTemplate = ({ c }) => {
  const items = Array.isArray(c.items) ? c.items : [];
  return (
    <div style={s.section}>
      {c.headline && <h1 style={{ ...s.h1, color: '#1e293b', marginBottom: 12 }}>{c.headline}</h1>}
      {c.subtext && <p style={{ ...s.body, marginBottom: 0 }}>{c.subtext}</p>}
      {items.length > 0 && (
        <div style={s.grid}>
          {items.map((item, idx) => (
            <div key={idx} style={s.card}>
              <div style={s.cardTitle}>{item.title}</div>
              <div style={s.cardBody}>{item.description}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const PromoTemplate = ({ c }) => {
  const gallery = Array.isArray(c.gallery) ? c.gallery.filter(Boolean) : [];
  const overlayColor = c.style === 'light' ? 'rgba(255,255,255,0.55)' : 'rgba(0,0,0,0.55)';
  const textColor = c.style === 'light' ? '#1e293b' : '#fff';
  return (
    <div style={s.section}>
      <div style={s.promoBox}>
        {c.bgImage && <img src={c.bgImage} alt="" style={s.promoBg} />}
        <div style={{ ...s.promoOverlay, background: overlayColor }} />
        <div style={{ ...s.promoContent, color: textColor }}>
          {c.headline && <h1 style={{ ...s.h1, color: textColor }}>{c.headline}</h1>}
          {c.subheading && <p style={{ fontSize: '1.15rem', fontWeight: 600, margin: '0 0 12px' }}>{c.subheading}</p>}
          {c.bodyText && <p style={{ fontSize: '1rem', opacity: 0.9, lineHeight: 1.7, margin: '0 0 24px' }}>{c.bodyText}</p>}
          {c.ctaLabel && (
            <a href={c.ctaUrl || '#'} style={{ ...s.ctaBtn, background: c.style === 'light' ? '#1e293b' : '#2563eb' }}>{c.ctaLabel}</a>
          )}
        </div>
      </div>
      {gallery.length > 0 && (
        <div style={s.galleryGrid}>
          {gallery.map((url, idx) => (
            <img key={idx} src={url} alt={`Gallery ${idx + 1}`} style={s.galleryImg} />
          ))}
        </div>
      )}
    </div>
  );
};

const NewsTemplate = ({ c }) => {
  const items = Array.isArray(c.items) ? c.items : [];
  return (
    <div style={s.section}>
      {c.headline && <h1 style={{ ...s.h1, color: '#1e293b', marginBottom: 8 }}>{c.headline}</h1>}
      {items.length > 0 && (
        <div style={s.newsGrid}>
          {items.map((item, idx) => (
            <div key={idx} style={s.newsCard}>
              {item.image && <img src={item.image} alt={item.title} style={s.newsImg} />}
              <div style={s.newsBody}>
                {item.date && <div style={s.newsDate}>{new Date(item.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</div>}
                {item.title && <div style={s.newsTitle}>{item.title}</div>}
                {item.body && <div style={s.newsText}>{item.body}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const StorePublicPageRenderer = ({ restaurantId, pageKey, storeName }) => {
  const [content, setContent] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!restaurantId || !pageKey) return;
    supabase
      .from('store_pages')
      .select('content, is_visible, is_archived')
      .eq('tenant_id', restaurantId)
      .eq('page_key', pageKey)
      .single()
      .then(({ data }) => {
        if (!data || data.is_archived || !data.is_visible) {
          setNotFound(true);
        } else {
          setContent(data.content || {});
        }
      });
  }, [restaurantId, pageKey]);

  if (notFound) {
    return (
      <div style={s.notFound}>
        <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>📄</div>
        <h2 style={{ margin: '0 0 8px', fontWeight: 700 }}>{PAGE_LABELS[pageKey] || 'Page'} not available</h2>
        <p style={{ margin: 0 }}>This page doesn't exist or has been hidden.</p>
      </div>
    );
  }

  if (content === null) {
    return <div style={s.loading}>Loading…</div>;
  }

  const c = content;

  switch (pageKey) {
    case 'home':     return <div style={s.shell}><HomeTemplate c={c} storeName={storeName} /></div>;
    case 'about':    return <div style={s.shell}><AboutTemplate c={c} /></div>;
    case 'contact':  return <div style={s.shell}><ContactTemplate c={c} /></div>;
    case 'features': return <div style={s.shell}><FeaturesTemplate c={c} /></div>;
    case 'promo':    return <div style={s.shell}><PromoTemplate c={c} /></div>;
    case 'news':     return <div style={s.shell}><NewsTemplate c={c} /></div>;
    default:         return <div style={s.notFound}><p>Unknown page type.</p></div>;
  }
};

export default StorePublicPageRenderer;
